import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ExamService} from '../../../../services/exam/exam.service';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-first-reading',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './first-reading.component.html',
  styleUrls: ['./first-reading.component.scss']
})
export class FirstReadingComponent implements OnInit, OnDestroy {

  @Input() idLevel: string;
  @Output() eventEmitter = new EventEmitter<string>();
  questions: any[] = [];

  answers: { [key: string]: string | undefined } = {};
  letters: string[] = ['A', 'B', 'C', 'D', 'E', 'F'];
  constructor(
    private examSrv: ExamService
  ) { }

  trackByIndex(index: number) { return index; }

  async ngOnInit(): Promise<void> {
    // Generate questions
    this.questions = await this.examSrv.generate(this.idLevel, 'FIRST_READING');
    this.questions.forEach((question) => {
      this.answers[question.question.uniqid] = undefined;
    });
  }

  selectAnswer(question, answer): void {
    this.answers[question.uniqid] = answer.uniqid;
  }

  isSelected(question, answer): boolean {
    return this.answers[question.uniqid] === answer.uniqid;
  }

  isAnswered(question): boolean {
    return this.answers[question.uniqid] !== undefined;
  }

  next(): void {
    this.eventEmitter.emit('FIRST_READING');
  }

  async ngOnDestroy(): Promise<void> {
    await this.examSrv.submit(this.idLevel, {
      answers: this.answers,
      type: 'FIRST_READING'
    });
  }
}
